export {
  initDatadog,
  ObservabilityErrorBoundary,
  exposeBuildVersion,
  getBuildVersion,
  logInfo,
  logError,
  addRumError,
  setUserContext,
  clearUserContext,
  getCorrelationKey,
  isInitialized,
} from "./observability";
